import React from 'react'
import {Col, Divider, Row} from "antd";
import RecipeInformationContainer from "./recipeInformation/RecipeInformationContainer";
import RecipeAbstract from "./recipeAbstract/RecipeAbstract";
import {RecipeProvider} from "../../../context/RecipeContext";

const RecipeCreateLayoutContainer = () => {



    return(
        <React.Fragment>
           <RecipeProvider>
               <Row justify={'space-between'}>
                   <Col span={20}>
                       <RecipeInformationContainer />
                   </Col>
                   <Col>
                       <Divider type={'vertical'} style={{
                           height: '100%'
                       }} />
                   </Col>
                   <Col span={3}>
                           <RecipeAbstract />
                   </Col>
               </Row>
           </RecipeProvider>
        </React.Fragment>
    )
}
export default RecipeCreateLayoutContainer